import { HeadlessForm } from '@universal-ember/form';

<template>
  <HeadlessForm as |form|>
    <form.Field @name="email" as |field|>
      <div class="my-2 flex flex-col">
        <field.Label>Email</field.Label>
        <field.Input
          @type="email"
          placeholder="Enter your email address"
          class="border rounded px-2"
        />
      </div>
    </form.Field>

    <form.Field @name="birthday" as |field|>
      <div class="my-2 flex flex-col">
        <field.Label>Birthday</field.Label>
        <field.Input @type="date" class="border rounded px-2" />
      </div>
    </form.Field>

    <button type="submit">Submit</button>
  </HeadlessForm>
</template>